import { ConfigService } from '@core/services/config.service';
import { Observable } from 'rxjs';
import { IConfig } from '@core/models/interfaces/config.interface';

export const loadConfigurationFactory = (configService: ConfigService): Observable<IConfig> => {
  return configService.load();
}
